module.exports = __webpack_public_path__ + "media/alert.18ad08b3.wav";